<template>
  <div>
    <date-picker
      class="datepicker"
      ref="dialog"
      v-model="date"
      type="time"
      editable
      format="HH:mm"
      placeholder="00:00"
      color="var(--color-primary)"
      :disabled="disabled"
      :input-attrs="{ style: { width: '100% !important' } }"
    ></date-picker>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import DateUtils from "../../utils/DateUtils";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    label: String,
    initTime: String,
    timeNow:Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    // //debugger
    if (this.initTime) {
      var aa = this.initTime
      console.log ('initTime : '+aa)
      
      this.date = this.initTime;
    } else {
      let today = new Date();
      const time = today.getHours() + ":" + today.getMinutes();
      this.date = time;
    }
  },
  data: () => ({
    date: "00:00",
    modal: false,
  }),
  computed: {},
  methods: {
    dateResult() {
      // //debugger
      console.log("Im here ", this.date);
      var time = (this.date) ? DateUtils.fixTimeFormatTwoDigit(this.date) : null ;
      console.log("time ", time);

      this.$emit("dateResult", time);
    },
  },
  watch: {
    date() {
      this.dateResult();
    },
    initTime(newval) {
      this.date = newval;
    },
  },
};
</script>

<style>
.datepicker {
  color: rgb(27, 27, 27);
}
</style>